import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(0.8, 0),
    width: '100%',
    overflow: 'auto',
  },
  awsImg: {
    height: theme.spacing(1.875),
    width: theme.spacing(2.75),
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  journey: {
    padding: theme.spacing(4, 0),
    overflow: 'auto',
    maxHeight: '280px',
  },
}))
